import { LayoutViewSwitcher } from './LayoutViewSwitcher'

export default LayoutViewSwitcher
